import { FormControl, FormGroup } from "@angular/forms";
import { CalcTemplate } from "./calctemplate";
import { Utility } from "./utility";
import { GougeModule } from "./gouge_module";

export class Component_MAEP {
  public static strFacility: string; // facility name
  public static strPlant: string; // plant name
  public static strEquipment: string; // equipment name
  public static strAnalyst: string; // analyst name
  public static intUnit_select: number; // 0 - US Customary, 1 - SI
  public static strD_class: string; // assessment type; GML, LTA, Pit, Gouge
  public static strD_result: string; // assessment result; pass or fail
  public static strD_iclass: number; // Defect type; GML = 0, LTA = 1, Pit = 2, Gouge = 3
  public static intEquip: number; // component type; 0-cylinder, 1-cone, 2-sphere, 3-ellip head, 4-F&D head 5-B31 piping
  public static sngIDo: number; // original inside diameter
  public static sngID: number; // corroded inside diameter
  public static sngtnom: number; // nominal thickness
  public static sngtrd: number; // current thickness
  public static sngtc: number; // future corroded thickness
  public static sngtctim: number; // future corroded thickness from tim calculation
  public static sngLOSSi: number; // internal metal loss
  public static sngLOSSe: number; // external metal loss
  public static sngFCAi: number; // internal future corrosion allowance
  public static sngFCAe: number; // external future corrosion allowance
  public static sngOD: number; // outside diameter
  public static sngP_d: number; // added variable
  public static sngFCA: number; // added variable
  public static sngtmin: number; // added variable
   public static sngMAWP: number; // MAWP of the component
  public static sngr: number; // added variable for Radius at the base of the gouge for dent
  public static sngL: number; // added variable for Unstiffened/unsupported length
  public static sngSMYS: number; // added variable for Minimum Specified Yield Strength at temperature, SMYS
  public static sngSMTS: number; // added variable for Minimum Specified Yield Strength at temperature, SMTS
  public static sngElast: number; // added variable for buckling coefficient
  public static f_he: number; // added variable for buckling coefficient
  public static a_e: number; // added variable for buckling coefficient
  public static Pa: number; // added variable for MAEP calculation
  public static readonly epsilon_vs: number = 0.002; // ϵvs = 0.002 declared as constant
  public static intmaterialstress: number; // Material Stress Selection Dropdown
  public static sngE_c: number; // circumferential joint efficiency
  public static sngtmin_L: number; // added variable
  public static sngalpha: number; // cone apex angle
  public static sngY_b: number; // B31.3 factor
  public static sngE_L: number; // longitudinal joint efficiency
  public static sngp_H: number; // head pressure
  public static sngS_stress: number; // allowable stress
  public static sngt_sl: number; // required thickness for supplemental loads (axial direction)
  public static sngTemp_d: number; // design temperature, input from report input screen only
  public static M1: number = -1;
  public static K: number = -1;
  public static A1: number = -1;
  public static A2: number = -1;
  public static sngM2: number = -1;
  public static initial_f_he: number = -1;
  public static initial_a_e: number = -1;
  public static initial_fic: number = -1;
  public static initial_pa: number = -1;
  public static fic: number = -1;
  public static epsilon_p: number = -1;
  public static sngRatio: number = -1;
  public static sngMZ: number = -1;
  public static sngCh: number = -1;
  public static buffer: string;
  public static buffer1: string;
  public static buffer2: string; // for sprintf operations
  public static strRadio: number = -1; // -1: not selected, 0: internal, 1: external
  public static validationMessage = [];
  public static validationMessageTypeOfData = [];
  public static alertMessage = [];

  public static MAEP_initialize(): void {
    this.intUnit_select = parseInt(localStorage.getItem("unitType")) || 0;
    this.strD_result = "";
    this.sngIDo = -1;
    this.sngID = -1;
    this.sngtnom = -1;
    this.sngtrd = -1;
    this.sngtc = -1;
    this.sngtctim = -1;
    this.sngSMTS = -1;
    this.sngL = -1;
    this.sngE_c = -1;
    this.sngLOSSi = -1;
    this.sngLOSSe = -1;
    this.sngFCAi = -1;
    this.sngFCAe = -1;
    this.sngCh = -1;
    this.f_he = -1;
    this.a_e = -1;
    this.sngM2 = -1;
    this.sngE_L = -1;
    this.fic = -1;
    this.sngOD = -1;
    this.sngP_d = -1;
    this.sngMAWP = -1;
    this.sngtmin = -1;
    this.sngTemp_d = -1;
    this.sngr = -1;
    this.epsilon_p = -1;
    this.sngMZ = -1;
    this.Pa = -1;
    this.sngp_H = 0;
    this.sngtmin_L = 0;
    this.sngalpha = -1;
    this.sngY_b = -1;
    this.sngS_stress = -1;
    this.sngt_sl = 0; //have to be 0 based on line 1169 in Form1.cpp
    CalcTemplate.reset_data();
    this.validationMessage = [];
    this.alertMessage = [];
  }

  public static ReturnMAWPValuesAsHTML(): string {
    let result =
      "this.intUnit_select" +
      this.intUnit_select +
      "</br>" +
      " strD_iclass: " +
      this.strD_iclass +
      "</br>" +
      " strD_result: " +
      this.strD_result +
      "</br>" +
      " intEquip: " +
      this.intEquip +
      "</br>" +
      " sngIDo: " +
      this.sngIDo +
      "</br>" +
      " sngID: " +
      this.sngID +
      "</br>" +
      " sngtnom: " +
      this.sngtnom +
      "</br>" +
      " sngtrd: " +
      this.sngtrd +
       "</br>" +
      " sngE_c: " +
      this.sngE_c +
      "</br>" +
      " sngE_L: " +
      this.sngE_L +
       "</br>" +
      " sngMAWP: " +
      this.sngMAWP +
      "</br>" +
      " sngTemp_d: " +
      this.sngTemp_d +
      "</br>" +
      " sngtc: " +
      this.sngtc +
       "</br>" +
      " sngtctim: " +
      this.sngtctim +
      "</br>" +
      " sngLOSSi: " +
      this.sngLOSSi +
      "</br>" +
      " sngLOSSe: " +
      this.sngLOSSe +
      "</br>" +
      " sngFCAi: " +
      this.sngFCAi +
      "</br>" +
      " sngFCAe: " +
      this.sngFCAe +
      "</br>" +
      " sngCh: " +
      this.sngCh +
      "</br>" +
      " f_he: " +
      this.f_he +
      "</br>" +
      " fic: " +
      this.fic +
      "</br>" +
      " a_e: " +
      this.a_e +
      "</br>" +
      " sngOD: " +
      this.sngOD +
      "</br>" +
      " sngP_d: " +
      this.sngP_d +
      "</br>" +
      " sngFCA: " +
      this.sngFCA +
      "</br>" +
      " sngtmin: " +
      this.sngtmin +
      "</br>" +
      " sngp_H: " +
      this.sngp_H +
      "</br>" +
      " sngr: " +
      this.sngr +
      "</br>" +
      " sngtmin_L: " +
      this.sngtmin_L +
      "</br>" +
      " sngalpha: " +
      this.sngalpha +
      "</br>" +
      " sngS_stress: " +
      this.sngS_stress +
      "</br>" +
      " sngt_sl: " +
      this.sngt_sl +
      "</br>" +
      " sngY_b: " +
      this.sngY_b +
      "</br>" +
      " sngL: " + this.sngL +
      "</br>" +
      " sngSMYS: " + this.sngSMYS +
      "</br>" +
      " sngSMTS: " + this.sngSMTS +
       "</br>" +
      " initial_f_he: " + this.initial_f_he +
      "</br>" +
      " initial_a_e: " + this.initial_a_e +
      "</br>" +
      " initial_fic: " + this.initial_fic +
      "</br>" +
      " strRadio: " + this.strRadio +
      "</br>" +
      " buffer: " +
      this.buffer +
      "</br>" +
      " buffer1: " +
      this.buffer1 +
      "</br>" +
      " buffer2: " +
      this.buffer2 +
      "</br>" +
      "Pa: " + this.Pa +
      "</br>" +
      "initial_pa: " + this.initial_pa +
      "</br>" +
      "intmaterialstress: " 
      + this.intmaterialstress;
    return result;
  }

  public static MAEP_calc(): string{
    //this.intUnit_select - unit selection: 0-US Customary, 1-SI
    let Epsilon_ys = 0.002; // ϵys = 0.002, constant for all materials
    let r = this.sngSMYS / this.sngSMTS; // ratio of minimum yield strength to minimum tensile strength

  // Calculate current measured thickness (sngtrd), future corroded thickness (sngtc) and general future corrosion allowance (sngFCA)
  if (this.intEquip != 6 && this.intEquip != 7) {
  // Calculate and store initial values
  this.calculateThicknessAndFCA();
  const Ro = this.calculateRo();
  if (!this.validateRo(Ro)) return "";
  //Calculate Mx, Ch
  const Mx = this.calculateMx(Ro);
  const Do_tc = this.sngIDo / this.sngtc;
  this.sngCh = this.calculateCh(Mx, Do_tc);

  this.sngRatio = Ro;
  this.sngMZ = Mx;
  // Calculate material factors (Dropdown Selection) Value
  this.calculateMaterialFactors(r);
  // Calculate M1, sngM2, K, A1, A2
   this.M1 = this.calculateM1(r, Epsilon_ys);
  this.sngM2 = 0.60 * (1.0 - r);
  this.K = this.calculateK(r);
  this.calculateA1A2(this.sngSMYS, this.sngSMTS, Epsilon_ys, this.M1);
  // Calculate fic, FS, Fha, Pa
  this.calculateBucklingFactors(this.sngElast, this.sngtc)
  this.fic = this.ficCalc(this.sngSMYS, this.sngSMTS, this.a_e, this.sngElast, Epsilon_ys, this.epsilon_p, this.M1, this.K);
  const FS = this.calculateFS(this.fic, this.sngSMYS);
  const { Fha, Pa } = this.calculateFhaPa(this.fic, FS);
  this.Pa = Pa;
  this.initial_pa = Pa;
  // Save all initial values to preserve
  const initialValues = {
    sngtc: this.sngtc,
    sngCh: this.sngCh,
    sngRatio: this.sngRatio,
    sngMZ: this.sngMZ,
    a_e: this.a_e,
    f_he: this.f_he,
    fic: this.fic,
    sngM2: this.sngM2,
    epsilon_p: this.epsilon_p,
    Pa: this.Pa,
  };

  // Calculate sngtmin using cal_tim (this will overwrite some values)
  this.sngtctim = this.sngtc; // Save before calling cal_tim()
  if (this.sngCh > 0 && this.sngtctim > 0 && this.sngIDo > 0 && this.sngElast > 0) {
    this.calculateBucklingFactors(this.sngElast, this.sngtctim);
    Component_MAEP.initial_f_he = this.f_he;
    Component_MAEP.initial_a_e = this.a_e;
    Component_MAEP.initial_fic = this.fic;
    Component_MAEP.initial_pa = this.Pa;
    Component_MAEP.sngMAWP = this.Pa;
  } else {
    Component_MAEP.initial_f_he = NaN;
    Component_MAEP.initial_a_e = NaN;
    Component_MAEP.initial_fic = NaN;
    Component_MAEP.initial_pa = NaN;
    Component_MAEP.sngMAWP = NaN;
  }
  //Calculate tim to get tmin Value
  const timResult = this.cal_tim();
  if (timResult && typeof timResult.tmin === "number") {
    this.sngtmin = timResult.tmin;
  }

  //Restore initial values so printout uses the first calculation
  Object.assign(this, initialValues);
}
 // Return formatted results
  return Component_MAEP.mewpReturnText();
}

private static calculateThicknessAndFCA(): void {
  this.sngtrd = this.sngtnom - this.sngLOSSi - this.sngLOSSe;
  this.sngFCA = this.sngFCAi + this.sngFCAe;
  this.sngtc = this.sngtrd - this.sngFCA;
}

private static calculateRo(): number {
  return this.sngIDo / 2;
}

private static validateRo(Ro: number): boolean {
  if (Ro === 0 || isNaN(Ro)) {
    this.sngRatio = 0;
    this.sngMZ = 0;
    this.sngCh = 0;
    this.validationMessage.push("Outside radius (Ro) is zero or invalid. Cannot proceed with external pressure calculations.");
    return false;
  }
  return true;
}

private static calculateMx(Ro: number): number {
  return Number((this.sngL / Math.sqrt(Ro * this.sngtc)));
}

private static calculateCh(Mx: number, Do_tc: number): number {
  const two_Do_tc_094 = Number((2 * Math.pow(Do_tc, 0.94)));
  if (Mx >= two_Do_tc_094) {
    return Number((0.55 * (this.sngtctim / this.sngIDo)));
  } else if (Mx > 13 && Mx < two_Do_tc_094) {
    return Number((1.12 * Math.pow(Mx, -1.058)));
  } else if (Mx > 1.5 && Mx <= 13) {
    return Number((0.92 / (Mx - 0.579)));
  } else if (Mx <= 1.5 && Mx >= 0) {
    return Number((1));
  } else {
    return NaN;
  }
}

private static calculateMaterialFactors(r: number): void {
  if (this.sngSMTS > 0 && this.sngSMYS > 0) {
    this.sngr = this.sngSMTS / this.sngSMYS;
  }

  if (GougeModule.intASME_curve == 0) {
    this.sngM2 = 0.6 * (1.0 - r);
    this.epsilon_p = 2.0 * Math.pow(10, -5);
  } else if (GougeModule.intASME_curve == 1) {
    this.sngM2 = 0.75 * (1.0 - r);
    this.epsilon_p = 2 * Math.pow(10, -5);
  } else if (GougeModule.intASME_curve == 2) {
    this.sngM2 = 0.7 * (1.0 - r);
    this.epsilon_p = 2 * Math.pow(10, -5);
  } else if (GougeModule.intASME_curve == 3) {
    this.sngM2 = 0.75 * (1.0 - r);
    this.epsilon_p = 2 * Math.pow(10, -5);
  } else if (GougeModule.intASME_curve == 4) {
    this.sngM2 = 0.52 * (.98 - r);
    this.epsilon_p = 2 * Math.pow(10, -6);
  } else if (GougeModule.intASME_curve == 5) {
    this.sngM2 = 0.5 * (1 - r);
    this.epsilon_p = 2 * Math.pow(10, -6);
  } else if (this.intEquip == 6) {
    this.sngM2 = 0.5 * (.98 - r);
    this.epsilon_p =2 * Math.pow(10, -5);
  }
}
// We are calculating F_he and A_e for both In cal_tim() and In MAEP_calc()
private static calculateBucklingFactors(Elast: number, thickness: number): void {
  this.f_he = Number(((1.6 * this.sngCh * Elast * thickness) / this.sngIDo));
  this.a_e = this.f_he / Elast;
}

private static calculateM1(r: number, Epsilon_ys: number): number {
  const numerator = Math.log(r) + (this.epsilon_p - Epsilon_ys);
  const denominator = Math.log(
    Math.log(1 + this.epsilon_p) / Math.log(1 + Epsilon_ys)
  );
  return numerator / denominator;
}

private static calculateK(r: number): number {
  const term1 = 1.5 * Math.pow(r, 1.5);
  const term2 = 0.5 * Math.pow(r, 2.5);
  const term3 = Math.pow(r, 3.5);
  return term1 - term2 - term3;
}

private static calculateA1A2(SMYS: number, SMTS: number, Epsilon_ys: number, M1: number): void {
  this.A1 = SMYS * (1 + Epsilon_ys) / Math.pow(Math.log(1 + Epsilon_ys), M1);
  this.A2 = SMTS * Math.exp(this.sngM2) / Math.pow(this.sngM2, this.sngM2);
}

private static calculateFS(Fic: number, SMYS: number): number {
  if (Fic <= 0.55 * SMYS) {
    return 2.0;
  } 
  else if (0.55 * SMYS < Fic && Fic < SMYS) {
    return 2.407 - 0.741 * (Fic / SMYS);
  }
   else if (Fic > SMYS) {
    return 1.667;
  }
}

private static calculateFhaPa(Fic: number, FS: number): {Fha: number, Pa: number} {
  const Fha = Fic / FS;
  this.Pa = 2 * Fha * (this.sngtc / this.sngIDo);
  return {Fha, Pa: this.Pa};
}

  private static mewpReturnText() {
    let result = "";

    switch (this.intUnit_select) {
      case 0: // US Customary
        result +=
          "Current measured thickness, trd = tnom - LOSSi - LOSSe = " +
          this.sngtrd.toFixed(3) +
          " inch<br />";
        result +=
          "Future corrosion allowance, FCA = FCAi + FCAe = " +
          this.sngFCA.toFixed(3) +
          " inch<br />";
        result +=
          "Future corroded thickness, tc = trd - FCA = " +
          this.sngtctim.toFixed(3) +
          " inch<br />";
        result +=
          "Elastic buckling stress, F_he = " +
          Component_MAEP.initial_f_he.toFixed(3) +
        " psi<br />";  
        result +=
          "Elastic buckling stress ratio factor, A_e = " +
          Component_MAEP.initial_a_e.toExponential(3) +
        "<br />";  
        result +=
          "Predicted inelastic buckling stress, F_ic = " +
          Component_MAEP.initial_fic.toFixed(3) +
        " psi<br />"; 
        result +=
          "Maximum Allowable External Pressure tc, MAEP = " +
        Component_MAEP.initial_pa.toFixed(3) +
        " psi<br />";   
        result +=
          "Minimum required thickness, tmin = " +
           this.sngtmin.toFixed(3) +
          " inch<br />";
        break;
      case 1:
           result +=
          "Current measured thickness, trd = tnom - LOSSi - LOSSe = " +
          this.sngtrd.toFixed(1) +
          " mm<br />";
        result +=
          "Future corrosion allowance, FCA = FCAi + FCAe = " +
          this.sngFCA.toFixed(1) +
          " mm<br />";
        result +=
          "Future corroded thickness, tc = trd - FCA = " +
          this.sngtctim.toFixed(1) +
          " mm<br />";
        result +=
          "Elastic buckling stress, F_he = " +
          Component_MAEP.initial_f_he.toFixed(2) +
        " MPa<br />";  
        result +=
          "Elastic buckling stress ratio factor, A_e = " +
          Component_MAEP.initial_a_e.toExponential(2) +
        "<br />";  
        result +=
          "Predicted inelastic buckling stress, F_ic = " +
          Component_MAEP.initial_fic.toFixed(2) +
        " MPa<br />"; 
        result +=
          "Maximum Allowable External Pressure tc, MAEP = " +
        Component_MAEP.initial_pa.toFixed(2) +
        " MPa<br />";   
        result +=
          "Minimum required thickness, tmin = " +
           this.sngtmin.toFixed(1) +
          " mm<br />";
        break;
    }
    return `<font color="blue">` + result + `</font>`;
  }


  public static calc_Check(inspectionDataFormGroup): boolean {
    
    this.validationMessage = [];
    this.alertMessage = [];

    let intUnit_select = 0;
    if (this.intUnit_select === 1) {
      intUnit_select = 1;
    }
    let messagesValidationsList: string[] = [];

    let textBox2_MAEP: FormControl =
      inspectionDataFormGroup.get("textBox2_MAEP");
    let textBox3_MAEP: FormControl =
      inspectionDataFormGroup.get("textBox3_MAEP");
    let textBox4_MAEP: FormControl =
      inspectionDataFormGroup.get("textBox4_MAEP");
    let textBox5_MAEP: FormControl =
      inspectionDataFormGroup.get("textBox5_MAEP");
    let textBox6_MAEP: FormControl =
      inspectionDataFormGroup.get("textBox6_MAEP");
    let textBox7_MAEP: FormControl =
      inspectionDataFormGroup.get("textBox7_MAEP");
    let textBox8_MAEP: FormControl =
      inspectionDataFormGroup.get("textBox8_MAEP");
    let textBox9_MAEP: FormControl =
      inspectionDataFormGroup.get("textBox9_MAEP");
    let textBox10_MAEP: FormControl =
      inspectionDataFormGroup.get("textBox10_MAEP");
    let textBox11_MAEP: FormControl =
      inspectionDataFormGroup.get("textBox11_MAEP");
    let textBox12_MAEP: FormControl =
      inspectionDataFormGroup.get("textBox12_MAEP");
    let textBox13_MAEP: FormControl =
      inspectionDataFormGroup.get("textBox13_MAEP");

    let checkFlag = true;
    let checkFlag1 = true; // added by shameer 5/2/2023
    let message1: string[] = [];
    let msg: string;
    let equipmentString: string;


    if (Component_MAEP.intEquip < 0 || Component_MAEP.intEquip > 8) {
      messagesValidationsList.push("Component not set.\n");
      checkFlag = false;
    }

   

    if (Component_MAEP.intEquip != 6) {
      // non-tanks
      //textBox2_MAEP error handling
      if (textBox2_MAEP.enabled) {
        equipmentString = "Original outside diameter, D - ";
        if (!Utility.isTextADouble(textBox2_MAEP.value)) {
          messagesValidationsList.push(equipmentString + msg + "\n");
          checkFlag = false;
        } else if (Component_MAEP.sngIDo <= 0) {
          messagesValidationsList.push(
            equipmentString + "cannot be less than or equal to zero.\n"
          );
          checkFlag = false;
        }
      }

      //textBox3_MAEP error handling
      if (textBox3_MAEP.enabled) {
        equipmentString = "Original nominal thickness, tnom - ";
        if (!Utility.isTextADouble(textBox3_MAEP.value)) {
          messagesValidationsList.push(equipmentString + msg + "\n");
          checkFlag = false;
        } else if (Component_MAEP.sngtnom <= 0) {
          //modified with new requirement
          messagesValidationsList.push(
            equipmentString + "cannot be less than or equal to zero.\n"
          );
          checkFlag = false;
        } else if (Component_MAEP.sngtnom > Component_MAEP.sngIDo / 4) {
          //modified with new requirement
          messagesValidationsList.push(
            equipmentString + "cannot be greater than D/4 .\n"
          );
          checkFlag = false;
        }
      }
      //textBox4_MAEP error handling
      if (textBox4_MAEP.enabled) {
        equipmentString = "Current uniform metal loss (internal), sngLOSSi - ";
        if (!Utility.isTextADouble(textBox4_MAEP.value)) {
          messagesValidationsList.push(equipmentString + msg + "\n");
          checkFlag = false;
        } else if (Component_MAEP.sngLOSSi < 0) {
          messagesValidationsList.push(
            equipmentString + "cannot be less than zero.\n"
          );
          checkFlag = false;
        }
      }
      //textBox5_MAEP error handling
      if (textBox5_MAEP.enabled) {
        equipmentString = "Current uniform metal loss (external), sngLOSSe - ";
        if (!Utility.isTextADouble(textBox5_MAEP.value)) {
          messagesValidationsList.push(equipmentString + msg + "\n");
          checkFlag = false;
        } else if (Component_MAEP.sngLOSSe < 0) {
          messagesValidationsList.push(
            equipmentString + "cannot be less than zero.\n"
          );
          checkFlag = false;
        }
      }
      //textBox6_MAEP error handling
      if (textBox6_MAEP.enabled) {
        equipmentString = "Future corrosion allowance (internal), sngFCAi - ";
        if (!Utility.isTextADouble(textBox6_MAEP.value)) {
          messagesValidationsList.push(equipmentString + msg + "\n");
          checkFlag = false;
        } else if (Component_MAEP.sngFCAi < 0) {
          messagesValidationsList.push(
            equipmentString + "cannot be less than zero.\n"
          );
        }
      }
      //textBox7_MAEP error handling
      if (textBox7_MAEP.enabled) {
        let equipmentString =
          "Future corrosion allowance (external), sngFCAe - ";
        if (!Utility.isTextADouble(textBox7_MAEP.value)) {
          messagesValidationsList.push(equipmentString + msg + "\n");
          checkFlag = false;
        } else if (Component_MAEP.sngFCAe < 0) {
          // modified
          messagesValidationsList.push(
            equipmentString + "cannot be less than zero.\n"
          );
          checkFlag = false;
        } else if (
          Component_MAEP.sngLOSSi +
          Component_MAEP.sngLOSSe +
          Component_MAEP.sngFCAi +
          Component_MAEP.sngFCAe >=
          Component_MAEP.sngtnom
        ) {
          // modified
          messagesValidationsList.push(
            "LOSSi + LOSSe + FCAi + FCAe cannot be greater than or equal to tnom.\n"
          );
          checkFlag = false;
        }
      }
      
      //textbox8_MAEP error handling
      if (textBox8_MAEP.enabled) {
        let equipmentString = "Equipment design pressure, P_d - ";
        if (!Utility.isTextADouble(textBox8_MAEP.value)) {
          messagesValidationsList.push(equipmentString + msg + "\n");
          checkFlag = false;
        } else if (Component_MAEP.sngP_d <= 0.0) {
          messagesValidationsList.push(
            equipmentString + "cannot be less than or equal to zero.\n"
          ); //modified
          checkFlag = false;
        }
      }
      //textBox9_MAEP error handling
      if (textBox9_MAEP.enabled) {
        let equipmentString = "Unstiffened/unsupported length, L_i - ";
        if (!Utility.isTextADouble(textBox9_MAEP.value)) {
          messagesValidationsList.push(equipmentString + msg + "\n");
          checkFlag = false;
        } else if (Component_MAEP.sngL <= 0.0) {
          messagesValidationsList.push(
            equipmentString + "cannot be less than or equal to zero.\n"
          ); //modified
          checkFlag = false;
        }
      }
      //textBox10_MAWP error handling
      if (textBox10_MAEP.enabled) {
        let equipmentString = "The input value for the Minimum Specified Yield Strength at temperature, SMYS";
        if (!Utility.isTextADouble(textBox10_MAEP.value)) {
          messagesValidationsList.push(equipmentString + msg + "\n");
          checkFlag = false;
        } else if (Component_MAEP.sngSMYS <= 0) {
          messagesValidationsList.push(
            equipmentString + " cannot be less than or equal to zero.\n"
          );
          checkFlag = false;
        } else if (intUnit_select === 0 && Component_MAEP.sngSMYS < 1500) {
          messagesValidationsList.push(
            equipmentString + " is out of Range.\n"
          );
          checkFlag = false;
        } else if (intUnit_select === 1 && Component_MAEP.sngSMYS < 10.34) {
          messagesValidationsList.push(
            equipmentString + " is out of Range.\n"
          );
          checkFlag = false;
        }
      }

      //textBox11_MAEP error handling
      if (textBox11_MAEP.enabled) {
        let equipmentString = "The input value for the Minimum Specified Tensile Strength at temperature, SMTS";
        if (!Utility.isTextADouble(textBox11_MAEP.value)) {
          messagesValidationsList.push(equipmentString + msg + "\n");
          checkFlag = false;
        } else if (Component_MAEP.sngSMTS <= 0) {
          messagesValidationsList.push(
            equipmentString + " cannot be less than or equal to zero.\n"
          );
          checkFlag = false;
        } else if (intUnit_select === 0 && Component_MAEP.sngSMTS < 1600) {
          messagesValidationsList.push(
            equipmentString + " is out of Range.\n"
          );
          checkFlag = false;
        } else if (intUnit_select === 1 && Component_MAEP.sngSMTS < 11.03) {
          messagesValidationsList.push(
            equipmentString + " is out of Range.\n"
          );
          checkFlag = false;
        }
      }

      // SMTS must be greater than SMYS (US and SI)
      if (
        (intUnit_select === 0 || intUnit_select === 1) &&
        Utility.isTextADouble(textBox10_MAEP.value) &&
        Utility.isTextADouble(textBox11_MAEP.value) &&
        Component_MAEP.sngSMTS <= Component_MAEP.sngSMYS
      ) {
        messagesValidationsList.push("The Minimum Specified Yield Strength at temperature, SMYS cannot be greater than the Minimum Specified Tensile Strength at temperature, SMTS.\n");
        checkFlag = false;
      }
            //textBox12_MAEP error handling
      if (textBox12_MAEP.enabled) {
        const equipmentString = "The input value for the Young's Modulus at temperature, E";
        if (!Utility.isTextADouble(textBox12_MAEP.value)) {
          messagesValidationsList.push(equipmentString + " - invalid value.\n");
          checkFlag = false;
        } else if (Component_MAEP.sngElast <= 0) {
          messagesValidationsList.push(
            equipmentString + " cannot be less than or equal to zero.\n"
          );
          checkFlag = false;
        } else if (intUnit_select === 0 && Component_MAEP.sngElast < 500000) {
          messagesValidationsList.push(
            equipmentString + " is out of range.\n"
          );
          checkFlag = false;
        } else if (intUnit_select === 1 && Component_MAEP.sngElast < 3447.4) {
          messagesValidationsList.push(
            equipmentString + " is out of range.\n"
          );
          checkFlag = false;
        }
      }
      //textBox13_MAEP error handling
      if (textBox13_MAEP.enabled) {
        let equipmentString = "Allowable Remaining Strength Factor, RSFa - ";
        if (!Utility.isTextADouble(textBox13_MAEP.value)) {
          messagesValidationsList.push(equipmentString + msg + "\n");
          checkFlag = false;
        } else if (CalcTemplate.sngRSF_a < 0.0) {
          messagesValidationsList.push(
            equipmentString + "cannot be less than zero.\n"
          );
          checkFlag = false;
        }
      }
        let comboBox1_DI_EquipInfo: FormControl = inspectionDataFormGroup.get("comboBox1_DI_EquipInfo");
      // Dropdown validation
      if (comboBox1_DI_EquipInfo && comboBox1_DI_EquipInfo.enabled) {
        let equipmentString = "Young's Modulus at temperature - ";
        if (!comboBox1_DI_EquipInfo.value || comboBox1_DI_EquipInfo.value === '') {
          messagesValidationsList.push(equipmentString + "Please select a component type.\n");
          checkFlag = false;
        }
      }
      
    }

    //check if there is an error
    if (!checkFlag) {
      this.validationMessage = !checkFlag ? messagesValidationsList : [];
      return false;
    } else {

    }

    this.alertMessage = !checkFlag1 ? message1 : [];
    return true;
  }

  public static check_GeneralMetalLoss_TypeOfData(generalmetalloss_formGroup): boolean {
    let passFlag: boolean = true;
    let messagesValidationsList: string[] = [];

    let radioButton_DIformControl: FormControl =
      generalmetalloss_formGroup.get("radioButton_DI");
   
  const validRadioBoxValues = ["radioButton1_DI_enabled", "radioButton2_DI_enabled"];

  if (radioButton_DIformControl?.enabled) {
    if (!validRadioBoxValues.includes(radioButton_DIformControl.value)) {
      passFlag = false;
      messagesValidationsList.push(
        "No type of damage selected."
      );
    }
  }

   this.validationMessageTypeOfData = !passFlag ? messagesValidationsList : [];
    return passFlag;
  }

  public static check_LocalMetalLoss_TypeOfData(localmetalloss_formGroup): boolean {
    let passFlag: boolean = true;
    let messagesValidationsList: string[] = [];

    let radioButton_DIformControl: FormControl =
      localmetalloss_formGroup.get("radioButton_DI");
   
  const validRadioBoxValues = ["radioButton1_DI_enabled", "radioButton2_DI_enabled"];

  if (radioButton_DIformControl?.enabled) {
    if (!validRadioBoxValues.includes(radioButton_DIformControl.value)) {
      passFlag = false;
      messagesValidationsList.push(
        "No type of damage selected."
      );
    }
  }

   this.validationMessageTypeOfData = !passFlag ? messagesValidationsList : [];
    return passFlag;
  }


  public static updateMAWPFormControls(MAEPFormGroup): void {
    let comboBox1_MAWP_formControl: FormControl = MAEPFormGroup.get(
      "selectedComponentType"
    );
    let textBox2_MAEP_formControl: FormControl =
      MAEPFormGroup.get("textBox2_MAEP");
    let textBox3_MAEP_formControl: FormControl =
      MAEPFormGroup.get("textBox3_MAEP");
    let textBox4_MAEP_formControl: FormControl =
      MAEPFormGroup.get("textBox4_MAEP");
    let textBox5_MAEP_formControl: FormControl =
      MAEPFormGroup.get("textBox5_MAEP");
    let textBox6_MAEP_formControl: FormControl =
      MAEPFormGroup.get("textBox6_MAEP");
    let textBox7_MAEP_formControl: FormControl =
      MAEPFormGroup.get("textBox7_MAEP");
    let textBox8_MAEP_formControl: FormControl =
      MAEPFormGroup.get("textBox8_MAEP");
    let textBox9_MAEP_formControl: FormControl =
      MAEPFormGroup.get("textBox9_MAEP");
    let textBox10_MAEP_formControl: FormControl =
      MAEPFormGroup.get("textBox10_MAEP");
    let textBox11_MAEP_formControl: FormControl =
      MAEPFormGroup.get("textBox11_MAEP");
    let textBox12_MAEP_formControl: FormControl =
      MAEPFormGroup.get("textBox12_MAEP");
    let textBox13_MAEP_formControl: FormControl =
      MAEPFormGroup.get("textBox13_MAEP");

    if ([7, 8].indexOf(Component_MAEP.strD_iclass) !== -1) {
      if (Component_MAEP.intEquip == 0)
        comboBox1_MAWP_formControl.setValue(Component_MAEP.intEquip);
      // intEquip = 1 for B31.3 Piping in Dents/DentGouge assessments and there are only 2 items in the combobox. Therefore, it needs to be set as "5", which is the value in combobox for B31.3 Piping
      else comboBox1_MAWP_formControl.setValue(5);
    } else {
      if (Component_MAEP.intEquip != -1) {
        comboBox1_MAWP_formControl.setValue(Component_MAEP.intEquip);
      }
    }

    if (Component_MAEP.intEquip != 8) {
      if (Component_MAEP.sngIDo != -1)
        textBox2_MAEP_formControl.setValue(Component_MAEP.sngIDo.toString());
    } else {
      if (Component_MAEP.sngID != -1)
        textBox2_MAEP_formControl.setValue(Component_MAEP.sngID.toString());
    }

    if (Component_MAEP.intEquip != 8) {
      if (Component_MAEP.sngtnom != -1)
        textBox3_MAEP_formControl.setValue(Component_MAEP.sngtnom.toString());
    } else {
      if (Component_MAEP.sngtc != -1)
        textBox3_MAEP_formControl.setValue(Component_MAEP.sngtc.toString());
    }

    if (Component_MAEP.intEquip != 8) {
      if (Component_MAEP.sngLOSSi != -1)
        textBox4_MAEP_formControl.setValue(Component_MAEP.sngLOSSi.toString());
    } else {
      if (CalcTemplate.sngMFH != -1)
        textBox4_MAEP_formControl.setValue(CalcTemplate.sngMFH.toString());
    }

    if (Component_MAEP.intEquip != 8) {
      if (Component_MAEP.sngLOSSe != -1)
        textBox5_MAEP_formControl.setValue(Component_MAEP.sngLOSSe.toString());
    } else {
      if (CalcTemplate.sngMFH_d != -1)
        textBox5_MAEP_formControl.setValue(CalcTemplate.sngMFH_d.toString());
    }

    if (Component_MAEP.intEquip != 8) {
      if (Component_MAEP.sngFCAi != -1)
        textBox6_MAEP_formControl.setValue(Component_MAEP.sngFCAi.toString());
    } else {
      if (Component_MAEP.sngtc != -1)
        textBox6_MAEP_formControl.setValue(Component_MAEP.sngtc.toString());
    }

    if (Component_MAEP.intEquip != 8) {
      if (Component_MAEP.sngFCAe != -1)
        textBox7_MAEP_formControl.setValue(Component_MAEP.sngFCAe.toString());
    }

    if (Component_MAEP.intEquip != 8) {
      if (Component_MAEP.sngP_d != -1)
        textBox8_MAEP_formControl.setValue(Component_MAEP.sngP_d.toString());
    } else {
      if (Component_MAEP.sngtmin != -1)
        textBox8_MAEP_formControl.setValue(Component_MAEP.sngtmin.toString());
    }

    if (Component_MAEP.intEquip != 8) {
      if (Component_MAEP.sngL != -1)
        textBox9_MAEP_formControl.setValue(
          Component_MAEP.sngL.toString()
        );
    } 
    if (Component_MAEP.intEquip != -1)
      textBox10_MAEP_formControl.setValue(Component_MAEP.sngSMYS.toString());

    if (Component_MAEP.intEquip != -1)
      textBox11_MAEP_formControl.setValue(
        Component_MAEP.sngSMTS != -1 ? Component_MAEP.sngSMTS.toString() : ""
      );
    if (Component_MAEP.intEquip != -1)
      textBox12_MAEP_formControl.setValue(
        Component_MAEP.sngSMTS != -1 ? Component_MAEP.sngElast.toString() : ""
      );
    
    if (CalcTemplate.sngRSF_a != -1)
        textBox13_MAEP_formControl.setValue(CalcTemplate.sngRSF_a.toString());

  }

  static getComponentType(intEquip: number): string {
    switch (intEquip) {
      case 0: return "Cylinder";
      case 1: return "Cone";
      default: return "Tank";
    }
  }
  
  private static ficCalc(
      YS: number,
      TS: number,
      Ae: number,
      Elast: number,
      Epsilon_ys: number,
      Epsilon_p: number,
      M1: number,
      K: number
    ): number {
      let F_up = YS;
      let F_low = 0.0;
      const tolerance = 0.0000001;
      let difference = 1.0;
      let Fic_g = 0.0;
      const maxIterations = 10000;
      let iterations = 0; 

      while (difference > tolerance && iterations < maxIterations) {
        Fic_g = 0.5 * (F_up + F_low);
        const Etg = this.tangentE(YS, TS, Fic_g, Elast, Epsilon_ys, Epsilon_p, M1, K);
        const Ai = Fic_g / Etg;
        difference = (Ai - Ae);

        if (difference < 0) F_low = Fic_g;
        else F_up = Fic_g;
          difference = Math.abs(difference);
        iterations++;
      }
      return Fic_g;
    }

  private static tangentE(
    YS: number,
    TS: number,
    Fic_g: number,
    Elast: number,
    Epsilon_ys: number,
    Epsilon_p: number,
    M1: number,
    K: number
  ): number {
    const H = this.calculateH(Fic_g, YS, TS, K);
    const HTan = Math.tanh(H);
    const c1 = 1 / M1;
    const c2 = 1 / this.sngM2;

    const D1 = Math.pow(Fic_g, c1 - 1) / (2 * M1 * Math.pow(this.A1, c1));
    
    const D2 = -0.5 * (1 / Math.pow(this.A1, c1)) *
      (Math.pow(Fic_g, c1) * (2 / (K * (TS - YS))) * (1 - Math.pow(HTan,2)) + c1 * Math.pow(Fic_g, c1 - 1) * HTan);

    const D3 = Math.pow(Fic_g, c2 - 1) / (2 * this.sngM2 * Math.pow(this.A2, c2));

    const D4 = 0.5 * (1 / Math.pow(this.A2, c2)) *
      (Math.pow(Fic_g, c2) * (2 / (K * (TS - YS))) * (1 - Math.pow(HTan, 2)) + c2 * Math.pow(Fic_g, c2 - 1) * HTan);

    return Math.pow((1 / Elast + D1 + D2 + D3 + D4), -1);
  }
  
private static calculateH(Fic_g: number, SMYS: number, SMTS: number, K: number): number {
  const numerator = Fic_g - (SMYS + K * (SMTS - SMYS));
  const denominator = K * (SMTS - SMYS);
  return 2 * (numerator / denominator);
}


  // Calculate minimum required thickness tmin for inspection tab
private static cal_tim(): any {
  let tmin_up = 2 * this.sngtnom;
  let tmin_low = 0.001;
  const tol_pde_diff = 1e-3;
  let pde_diff = 1;
  let tmin_g = 0;
  const Epsilon_ys = 0.002;
  
  let iterations = 0;
  const maxIterations = 10000;
  let lastTminG = -1;
  let noProgressCount = 0;
  const maxNoProgress = 10;

  // Validate initial conditions
  if (this.sngIDo <= 0 || this.sngtnom <= 0 || this.sngElast <= 0 || this.sngP_d <= 0) {
    console.error('cal_tim(): Invalid initial conditions', {
      sngIDo: this.sngIDo,
      sngtnom: this.sngtnom,
      sngElast: this.sngElast,
      sngP_d: this.sngP_d
    });
    return { tmin: NaN, pde_diff: NaN, error: 'Invalid initial conditions' };
  }

  while (pde_diff > tol_pde_diff && iterations < maxIterations) {
    iterations++;
    
    // Calculate tmin_g
    tmin_g = 0.5 * (tmin_up + tmin_low);
    
    // Ensure tmin_g is reasonable
    if (tmin_g <= 0 || tmin_g > 2 * this.sngtnom) {
      console.error('cal_tim(): tmin_g out of reasonable bounds', { tmin_g, sngtnom: this.sngtnom });
      break;
    }
    
    // Check for no progress (oscillation)
    if (Math.abs(tmin_g - lastTminG) < 1e-10) { // Changed from 1e-100 to more reasonable tolerance
      noProgressCount++;
      if (noProgressCount >= maxNoProgress) {
        console.warn(`cal_tim(): No progress detected after ${noProgressCount} iterations. Breaking loop.`);
        break;
      }
    } else {
      noProgressCount = 0;
    }
    lastTminG = tmin_g;
    
    // Check for valid bounds convergence
    if (Math.abs(tmin_up - tmin_low) < 1e-8) { // Changed from 1e-100
      console.log('cal_tim(): Bounds converged. Breaking loop.');
      break;
    }
    
    this.sngtc = tmin_g;
    
    // Validate input values
    if (this.sngtc <= 0 || this.sngIDo <= 0 || this.sngElast <= 0) {
      console.error('cal_tim(): Invalid input values', {
        sngtc: this.sngtc,
        sngIDo: this.sngIDo,
        sngElast: this.sngElast
      });
      return { tmin: NaN, pde_diff: NaN, error: 'Invalid input values' };
    }
    
    const Ro = this.calculateRo();
    if (!this.validateRo(Ro) || Ro <= 0) {
      console.error('cal_tim(): Invalid Ro', { Ro });
      return { tmin: NaN, pde_diff: NaN, error: 'Ro validation failed' };
    }
    
    const Mx = this.calculateMx(Ro);
    if (isNaN(Mx) || Mx <= 0) {
      console.error('cal_tim(): Invalid Mx', { Mx, Ro, L: this.sngL, sngtc: this.sngtc });
      return { tmin: NaN, pde_diff: NaN, error: 'Invalid Mx value' };
    }
    
    const Do_tc = this.sngIDo / this.sngtc;
    if (isNaN(Do_tc) || Do_tc <= 0) {
      console.error('cal_tim(): Invalid Do_tc', { Do_tc, sngIDo: this.sngIDo, sngtc: this.sngtc });
      return { tmin: NaN, pde_diff: NaN, error: 'Invalid Do_tc value' };
    }
    
    this.sngCh = this.calculateCh(Mx, Do_tc);
    
    // More detailed Ch validation
    if (isNaN(this.sngCh) || this.sngCh <= 0 || !isFinite(this.sngCh)) {
      console.error('cal_tim(): Invalid Ch value', { 
        Ch: this.sngCh, 
        Mx: Mx, 
        Do_tc: Do_tc,
        tmin_g: tmin_g,
        iteration: iterations 
      });
      
      // Try to recover by adjusting bounds
      if (pde_diff > 0) {
        tmin_low = tmin_g;
      } else {
        tmin_up = tmin_g;
      }
      continue; // Skip this iteration and try next
    }
    
    this.sngRatio = Ro;
    this.sngMZ = Mx;
    
    // Calculate f_he and a_e value
    this.calculateBucklingFactors(this.sngElast, this.sngtc);
    
    // Check if buckling factors are valid
    if (isNaN(this.f_he) || isNaN(this.a_e) || this.a_e <= 0 || !isFinite(this.f_he) || !isFinite(this.a_e)) {
      console.error('cal_tim(): Invalid buckling factors', { f_he: this.f_he, a_e: this.a_e });
      
      // Try to recover
      if (pde_diff > 0) {
        tmin_low = tmin_g;
      } else {
        tmin_up = tmin_g;
      }
      continue;
    }
    
    // Calculate Fic Value
    this.fic = this.ficCalc(this.sngSMYS, this.sngSMTS, this.a_e, this.sngElast, Epsilon_ys, this.epsilon_p, this.M1, this.K);
    
    // Check if Fic is valid
    if (isNaN(this.fic) || this.fic <= 0 || !isFinite(this.fic)) {
      console.error('cal_tim(): Invalid Fic value', { fic: this.fic });
      
      // Try to recover
      if (pde_diff > 0) {
        tmin_low = tmin_g;
      } else {
        tmin_up = tmin_g;
      }
      continue;
    }
    
    // Calculate FS, Fha, Pa
    const FS = this.calculateFS(this.fic, this.sngSMYS);
    const { Fha, Pa } = this.calculateFhaPa(this.fic, FS);
    
    // Check if Pa is valid
    if (isNaN(Pa) || Pa <= 0 || !isFinite(Pa)) {
      console.error('cal_tim(): Invalid Pa value', { Pa, FS, Fha });
      
      // Try to recover
      if (pde_diff > 0) {
        tmin_low = tmin_g;
      } else {
        tmin_up = tmin_g;
      }
      continue;
    }
    
    // Update Pde_diff
    pde_diff = this.sngP_d - Pa;
    
    if (pde_diff < 0) {
      tmin_up = tmin_g;
    } else {
      tmin_low = tmin_g;
    }
    
    pde_diff = Math.abs(pde_diff);
    
    // Log progress every 50 iterations
    if (iterations % 50 === 0) {
      console.log(`cal_tim() iteration ${iterations}: tmin_g=${tmin_g.toFixed(6)}, Pa=${Pa.toFixed(6)}, P_d=${this.sngP_d.toFixed(6)}, pde_diff=${pde_diff.toFixed(8)}`);
    }
  }
  
  // Check exit conditions
  if (iterations >= maxIterations) {
    console.warn(`cal_tim(): Maximum iterations (${maxIterations}) reached. pde_diff=${pde_diff}`);
    return { tmin: tmin_g, pde_diff: pde_diff, error: 'Max iterations reached', iterations: iterations };
  }
  
  if (noProgressCount >= maxNoProgress) {
    console.warn(`cal_tim(): No progress detected. Final pde_diff=${pde_diff}`);
    return { tmin: tmin_g, pde_diff: pde_diff, error: 'No progress', iterations: iterations };
  }
  
  // Successful completion
  this.sngtmin = tmin_g;
  this.sngtc = this.sngtctim; // Restore sngtc to original value after calculation
  
  console.log(`cal_tim() completed successfully in ${iterations} iterations. Final pde_diff=${pde_diff.toFixed(8)}, tmin=${tmin_g.toFixed(6)}`);
  return { tmin: tmin_g, pde_diff: pde_diff, iterations: iterations };
}

  // Add this new function to Component_MAEP - existing cal_tim() stays unchanged
public static cal_MAEPR_external(tc_value: number): any {
  // Store original values
  const original_sngtc = this.sngtc;
  const original_sngtctim = this.sngtctim;
  const Epsilon_ys = 0.002;
  
   this.sngtc = tc_value
      const Ro = this.calculateRo();
      if (!this.validateRo(Ro)) return; // handle error
      //Calculate Mx Value
      const Mx = this.calculateMx(Ro);
      const Do_tc = this.sngIDo / this.sngtc;
      //Calculate Ch Value
      this.sngCh = this.calculateCh(Mx, Do_tc);
      this.sngRatio = Ro;
      this.sngMZ = Mx;
      this.sngCh = this.sngCh;
      //Calculate f_he and a_e value
      this.calculateBucklingFactors(this.sngElast, this.sngtc);
      // Calculate Fic Value
      this.fic = this.ficCalc(this.sngSMYS, this.sngSMTS, this.a_e, this.sngElast, Epsilon_ys, this.epsilon_p, this.M1, this.K);
      // Calculate FS, Fha, Pa
      const FS = this.calculateFS(this.fic, this.sngSMYS);
      const {Fha, Pa} = this.calculateFhaPa(this.fic, FS);
  
  return Pa;
}

// Add this to calculate external pressure at given tc for MAEP - returns null if any error occurs, otherwise returns Pa value
public static calcExternalAtTc(tcValue: number): { Pa: number } | null {
  const Ro = this.calculateRo();
  const Mx = Number((this.sngL / Math.sqrt(Ro * tcValue)));
  const Do_tc = this.sngIDo / tcValue;
  const two_Do_tc_094 = Number((2 * Math.pow(Do_tc, 0.94)));
  let Ch: number;
  if (Mx >= two_Do_tc_094) {
    Ch = Number((0.55 * (this.sngtctim / this.sngIDo)));
  } else if (Mx > 13 && Mx < two_Do_tc_094) {
    Ch = Number((1.12 * Math.pow(Mx, -1.058)));
  } else if (Mx > 1.5 && Mx <= 13) {
    Ch = Number((0.92 / (Mx - 0.579)));
  } else if (Mx <= 1.5 && Mx >= 0) {
    Ch = 1;
  } else {
    Ch = NaN;
  }
  if (isNaN(Ch) || Ch <= 0 || !isFinite(Ch)) {
    console.error("calcExternalAtTc(): Invalid Ch", { Ch, Mx, tcValue });
    return null;
  }

  const f_he = Number(((1.6 * Ch * this.sngElast * tcValue) / this.sngIDo));
  const a_e = f_he / this.sngElast;
  if (isNaN(f_he) || isNaN(a_e) || a_e <= 0 || !isFinite(f_he) || !isFinite(a_e)) {
    //console.error("calcExternalAtTc(): Invalid buckling factors", { f_he, a_e });
    return null;
  }

  const Epsilon_ys = 0.002;
  const fic = this.ficCalc(this.sngSMYS, this.sngSMTS, a_e, this.sngElast, Epsilon_ys, this.epsilon_p, this.M1, this.K);
  if (isNaN(fic) || fic <= 0 || !isFinite(fic)) {
    console.error("calcExternalAtTc(): Invalid Fic", { fic });
    return null;
  }

  const FS = this.calculateFS(fic, this.sngSMYS);
  if (FS === undefined || isNaN(FS) || FS <= 0) {
    console.error("calcExternalAtTc(): Invalid FS", { FS, fic, sngSMYS: this.sngSMYS });
    return null;
  }

  const Fha = fic / FS;
  const Pa = 2 * Fha * (tcValue / this.sngIDo);
  if (isNaN(Pa) || Pa <= 0 || !isFinite(Pa)) {
    console.error("calcExternalAtTc(): Invalid Pa", { Pa, FS, Fha });
    return null;
  }
  return { Pa };
}

}
